import 'vazir-font/dist/Farsi-Digits/font-face-FD.css'
import '@fontsource/open-sans'
import '../styles/global.css'
import '../styles/animation.css'
import 'antd/dist/antd.css'
import { UserProvider } from '../hooks/User'
import { ThemeProvider } from '@emotion/react'
import config from '../../config.json'
import { DataProvider } from '../hooks/dataProvider/DataProvider'

import { appWithTranslation } from 'next-i18next'
import nextI18NextConfig from '../../next-i18next.config.js'

const Noop = ({ children }) => <>{children}</>

const nullTheme = {
    "colors": {
        "nav": {},
        "websiteHeader": {},
        "websiteFooter": {},
        "accordion": {
        }
    },
    "font": {
        "default": {},
        "en": {
        }
    },
    "fontSize": {
    },
    "spacing": {
    },
    "boxShadow": {
    },
    "screens": {
    },
    "borderRadius": {
    },
    "typography": {
        "h1": {},
        "h2": {},
        "h3": {},
        "h4": {},
        "h5": {},
        "h6": {},
        "p": {},
        "t": {
        }
    },
    "components": {
        "logo": {},
        "logoFooter": {},
        "websiteHeader": {}
    }
}

function MyApp({ Component, pageProps }) {
    const Layout = Component.Layout || Noop
    return (
        <ThemeProvider theme={config.theme ?? nullTheme}>
            <UserProvider>
                <DataProvider>
                    <Layout pageProps={pageProps}>
                        <Component {...pageProps} />
                    </Layout>
                </DataProvider>
            </UserProvider>
        </ThemeProvider>
    )
}

export default appWithTranslation(MyApp, nextI18NextConfig)
